import { render, staticRenderFns } from "./ResourceEditor.vue?vue&type=template&id=985f3e8a"
import script from "./ResourceEditor.vue?vue&type=script&lang=js"
export * from "./ResourceEditor.vue?vue&type=script&lang=js"
import style0 from "./ResourceEditor.vue?vue&type=style&index=0&id=985f3e8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports